export const currencies = {
	SEK: { short: "SEK", long: "Svensk krona", preset: ["sv"] },
	NOK: { short: "NOK", long: "Norsk krone", preset: ["no", "nb", "nn"] },
	DKK: { short: "DKK", long: "Dansk krone", preset: ["dk"] },
	ISK: { short: "ISK", long: "Isländsk króna", preset: ["is"] },
	EUR: { short: "Euro", long: "Euro", preset: ["fi", "nl"] },
	GBP: { short: "Pound", long: "Pound sterling" },
	USD: { short: "USD", long: "US Dollars" },
	RUB: { short: "RUB", long: "Rysk rubel" },
	BRL: { short: "BRL", long: "Brasiliansk real" },
	THB: { short: "THB", long: "Thai baht", preset: ["th"] },
};
